import React from 'react';
import type { SVGProps } from 'react';
const SvgX = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 19"
    {...props}
  >
    <g clipPath="url(#x_svg__a)">
      <path
        fill={props?.fill || 'rgb(172, 185, 201)'}
        d="M10.82 8.118 17.373.5H15.82l-5.69 6.614L5.585.5H.343l6.873 10.002-6.873 7.989h1.553l6.01-6.985 4.8 6.985h5.241zM8.693 10.59l-.696-.996L2.456 1.67H4.84l4.472 6.396.696.996 5.812 8.314h-2.385z"
      />
    </g>
    <defs>
      <clipPath id="x_svg__a">
        <path     
         fill={props?.fill || 'rgb(172, 185, 201)'}
         d="M.343.5h17.604v18H.343z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgX;
